// Trip ID Constants
// This object maps trip names to their corresponding IDs used in the system

export const TRIP_ID = {
  COORG: "JkcQxd4iLK",
  WAYNAD: "CUeNCXbuiv", 
  CHIKMANGLUR: "b7OJeOpc2O",
  MYSURU: "5tYSmlOpvb",
  GUDIBANDE: "63TgX4uVfH",
  LEPAKSHI: "oMrlY9tp6M",
  UTTARI_BETTA: "BX6NVDS9XJ",
  NANDI_HILLS: "1vtBFlfbb4",
  DD_HILLS: "v7vjoATneH",
  HOGENAKKAL_FALL: "3Cxl2Fi53Q",
  PONDICHERRY: "YMxaaijRWz",
  KOTI: "pWGxBYhefJ",
  OOTY_RESORT_STAY: "UShl5lIvKk",
  GOKARNA: "2sHmYBlj6Z",
  KODAIKANAL: "nrEDi9EXC0"
} as const;

// Type for trip ID values
export type TripId = typeof TRIP_ID[keyof typeof TRIP_ID];

// Helper function to get trip name by ID (reverse lookup)
export const getTripNameById = (id: string): string | undefined => {
  const entry = Object.entries(TRIP_ID).find(([_, value]) => value === id);
  return entry ? entry[0] : undefined;
};

// Helper function to get trip ID by name
export const getTripIdByName = (name: keyof typeof TRIP_ID): string => {
  return TRIP_ID[name];
};

// Array of all trip IDs for iteration
export const ALL_TRIP_IDS = Object.values(TRIP_ID);

// Array of all trip names for iteration  
export const ALL_TRIP_NAMES = Object.keys(TRIP_ID) as Array<keyof typeof TRIP_ID>;
